import { BSkeleton } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBSkeleton = createEgBootstrapProxy("EgBSkeleton", BSkeleton);
